export const footerText = '© Powered by MediaOne';
